import {excess} from '@fl/cmsch-fe-library';
import * as t from 'io-ts';

const requiredPart = excess(t.partial({
    approvedFrom: t.string,
    approvedTo: t.string,
    roleIds: t.string,
    otherSubjectId: t.string,
    userProfileId: t.string,
}));

/** Validation error schema for other-subject-management bindings. */
export const ValidateOtherSubjectErrorsSchema = t.interface({binding: requiredPart});
